import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdRelationshipChartsDataContext } from './hooks/useHouseholdRelationshipChartsDataContext';

export const KnowAboutFather = () => {
    const { chartData } = useHouseholdRelationshipChartsDataContext();

    return (
        <Donut
            title={'Conhecimento sobre o Pai'}
            subtitles={chartData?.knowAboutFather?.map((item) => item.description)}
            chartData={chartData?.knowAboutFather || []}
            colors={defaultColors.slice(0, chartData?.knowAboutFather?.length) || []}
            height={350}
        />
    );
};
